"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
var BaseTranslate = /*#__PURE__*/function () {
  function BaseTranslate(e) {
    var _this = this;
    _classCallCheck(this, BaseTranslate);
    // e is an object with the content of the page

    /*
        For each block of content there is,
        loop through it and get the content in
        the current language of the project and
        return it to be used in getContent().
         The object received must be structured as followed:
        {
            title_content: { nl: 'content', fr: 'content', en: 'content', ..: .. },
            title_content: { nl: 'content', fr: 'content', en: 'content', ..: .. },
        }
    */
    Object.keys(e).forEach(function (key) {
      return _this[key] = e[key];
    });
  }

  /*
      getContent() will be used throughout the project
      to return the specific content you're asking for.
      No need to ask for content in a specific, 
      that's handled for you
  */
  _createClass(BaseTranslate, [{
    key: "getContent",
    value: function getContent(e) {
      var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
      if (this[e]) {
        if (this[e][lang]) return this[e][lang];else return "Can't get translation (" + lang + ")"; // Fallback in case content is not yet available in the current language
      } else return "Can't get content"; // Fallback in case the content you're asking for has not yet been created
    }
  }]);
  return BaseTranslate;
}();
exports["default"] = BaseTranslate;